import { TelemetryRecord } from '../../diagnostics/telemetry-record';
import { RpcBaseData } from '../rpc-base';

/**
 * RPC telemetry command and version.
 */
export class RpcTelemetryKey {
    public static command = 'Telemetry';
    public static version = '0.1.0';
}

/**
 * Rpc telemetry record.
 */
export interface RpcTelemetryRecord extends TelemetryRecord, RpcBaseData {
    /**
     * The client session ID which is auto generated when user opened the site.
     * This should be auto inserted when logging submitted to the back-end.
     */
    sessionId: string;

    /**
     * The timestamp. Date.now() / the number of milliseconds elapsed since 1 January 1970 00:00:00 UTC.
     */
    timestamp: number;
}
